import createItemFetcher from "../helpers/item";
import { createUseItem } from "../helpers/fetchHooks";
import { createActionDuck } from "../helpers/action";
import { createUseAction } from "../helpers/actionHooks";
import { createNotificationsEpic } from "../helpers/notifications";
const computeTriggersId = () => "focasTriggers";
const computeFocasTriggersUrl = () => "/api/v1/aggregation-service/triggers";
const getFocasTriggers = createItemFetcher(computeFocasTriggersUrl, "FOCAS_TRIGGERS_GET", computeTriggersId);
export const useFetchFocasTriggers = createUseItem(getFocasTriggers, (state) => state.focasTriggers.triggers);
const computeCreateFocasTriggerUrl = () => ({
    url: "/api/v1/aggregation-service/triggers",
    method: "POST",
});
const focasTriggersCreateDuck = createActionDuck("FOCAS_TRIGGER_CREATE", computeCreateFocasTriggerUrl, computeTriggersId);
focasTriggersCreateDuck.middleware = focasTriggersCreateDuck.middleware.concat(createNotificationsEpic(focasTriggersCreateDuck.ActionKeys, "Trigger created", () => ""));
export const useCreateFocasTriggers = createUseAction(focasTriggersCreateDuck, (state) => state.focasTriggers.create);
const computeUpdateFocasTriggerUrl = (triggerName) => ({
    url: `/api/v1/aggregation-service/triggers/${triggerName}`,
    method: "PUT",
});
const focasTriggersUpdateDuck = createActionDuck("FOCAS_TRIGGER_UPDATE", computeUpdateFocasTriggerUrl, computeTriggersId);
focasTriggersUpdateDuck.middleware = focasTriggersUpdateDuck.middleware.concat(createNotificationsEpic(focasTriggersUpdateDuck.ActionKeys, "Trigger updated", () => ""));
export const useUpdateFocasTriggers = createUseAction(focasTriggersUpdateDuck, (state) => state.focasTriggers.update);
const compuetDeleteFocasTriggerUrl = (triggerName) => ({
    url: `/api/v1/aggregation-service/triggers/${triggerName}`,
    method: "DELETE",
});
const focasTriggerDeleteDuck = createActionDuck("FOCAS_TRIGGER_DELETE", compuetDeleteFocasTriggerUrl, computeTriggersId);
focasTriggerDeleteDuck.middleware = focasTriggerDeleteDuck.middleware.concat(createNotificationsEpic(focasTriggerDeleteDuck.ActionKeys, "Trigger deleted", () => ""));
export const useDeleteFocasTriggers = createUseAction(focasTriggerDeleteDuck, (state) => state.focasTriggers.delete);
export function createFocasTriggersActions() {
    const computeGetFocasTriggerUrl = (triggerName) => `/api/v1/aggregation-service/triggers/${triggerName}`;
    const getFocasTrigger = createItemFetcher(computeGetFocasTriggerUrl, "FOCAS_TRIGGER_GET", computeTriggersId);
    return {
        create: focasTriggersCreateDuck,
        update: focasTriggersUpdateDuck,
        delete: focasTriggerDeleteDuck,
        triggers: getFocasTriggers,
        trigger: getFocasTrigger,
    };
}
//# sourceMappingURL=focasTriggersActions.js.map